import { Dimensions } from "src/types/configuration";

export const calculateHeight = (dimensions: Dimensions): number => {
  const angleRadians = (dimensions.angle * Math.PI) / 180;
  const halfBase = dimensions.depth / 2;
  const equalSide = dimensions.depth / (2 * Math.cos(angleRadians));
  const roofHeight = Math.sqrt(equalSide ** 2 - halfBase ** 2);

  return roofHeight + dimensions.height;
};

export const fromMmToUnit = (valueInMm: number, unit: "mm" | "cm"): number => {
  if (unit === "cm") {
    return valueInMm / 10;
  }
  return valueInMm;
};

export const fromUnitToMm = (
  valueInUnit: number,
  unit: "mm" | "cm",
): number => {
  if (unit === "cm") {
    return valueInUnit * 10;
  }
  return valueInUnit;
};
